import axios from "axios";
import { create } from "zustand";

const brandStore = create((set) => ({
  brand: null,
  MAX_FILE_SIZE: 1500,

  brandForm: {
    brandName: "",
    brandSlogan: "",
    brandLogo: "",
    brandLogoPreview: "",
    brandEmail: "",
    brandContactUs: "",
    brandAddress: "",
    brandAbout: "",
  },

  validation: {
    brandName: false,
    brandEmail: false,
  },

  clearValidation: () => {
    set({
      validation: {
        brandName: false,
        brandLogo: false,
        brandEmail: false,
      },
    });
  },

  setValidate: ({ name, value }) => {
    set((state) => {
      return {
        validation: {
          ...state.validation,
          [name]: value,
        },
      };
    });
  },

  fetchBrand: async () => {
    // Fetch brand
    const res = await axios.get("/brand");
    // set brand to state
    set({ brand: res.data.brand });
  },

  setFormData: () => {
    const { brand } = brandStore.getState();
    set({
      brandForm: {
        brandName: brand.brandName,
        brandSlogan: brand.brandSlogan,
        brandLogo: brand.brandLogo,
        brandEmail: brand.brandEmail,
        brandContactUs: brand.brandContactUs,
        brandAddress: brand.brandAddress,
        brandAbout: brand.brandAbout,
      },
    });
  },

  fillBrandDetails: (e) => {
    const { name, value } = e.target;
    set((state) => {
      return {
        brandForm: {
          ...state.brandForm,
          [name]: value,
        },
      };
    });
  },

  fillBrandLogo: async ({ files }) => {
    const { convertToBase64, MAX_FILE_SIZE } = brandStore.getState();
    if (MAX_FILE_SIZE < files[0].size / 1024) return false;

    // const base64 = await convertToBase64(files[0]);
    set((state) => {
      return {
        brandForm: {
          ...state.brandForm,
          brandLogo: files[0],
          brandLogoPreview: URL.createObjectURL(files[0]),
        },
      };
    });
    return true;
  },

  convertToBase64: (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  },

  updateBrand: async () => {
    try {
      const { brandForm } = brandStore.getState();
      // set data in FromData
      var brandFromData = new FormData();
      brandFromData.append("brandName", brandForm.brandName);
      brandFromData.append("brandSlogan", brandForm.brandSlogan);
      if (brandForm.brandLogo) {
        brandFromData.append("brandLogo", brandForm.brandLogo);
      }
      brandFromData.append("brandEmail", brandForm.brandEmail);
      brandFromData.append("brandContactUs", brandForm.brandContactUs);
      brandFromData.append("brandAddress", brandForm.brandAddress);
      brandFromData.append("brandAbout", brandForm.brandAbout);

      // send the update request
      const res = await axios.put("/update-brand", brandFromData);

      // set brand to state
      set({ brand: res.data.brand });
      set((state) => {
        return {
          brandForm: {
            ...state.brandForm,
            brandLogoPreview: "",
          },
        };
      });
    } catch (error) {
      console.log("error: ", error);
    }
  },
}));

export default brandStore;
